import graphql from "babel-plugin-relay/macro";
import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";

let query = graphql`
   query LoadNotifQuery($id: ID!, $scope: String){
      notifications(id: $id, scope: $scope){
        id
        notifications {
          id
          createdAt
          status
          header
          body
          sourceId
          sourceType
          sourceStatus
        }
      }
    }
  `;

export default (id, scope) => {
  let variables = { id, scope };
  return fetchQuery(environment, query, variables)
}